import { Ace as AceNamespace } from 'ace-builds';
import { MutableRefObject, createContext, useContext } from 'react';

import { AceEditorTheme } from 'modules/aceEditor';
import { noop } from 'utils/noop';

type SideBySideEditorContextState = {
  aceEditorTheme: AceEditorTheme;
  editor: MutableRefObject<AceNamespace.Editor | null>;
  redo: () => void;
  selectedImage?: HTMLImageElement;
  selectedAnchor?: HTMLAnchorElement;
  setSelectedImage: (element?: HTMLImageElement) => void;
  setSelectedAnchor: (element?: HTMLAnchorElement) => void;
  undo: () => void;
};

const SIDE_BY_SIDE_EDITOR_CONTEXT_DEFAULT_VALUE: SideBySideEditorContextState = {
  aceEditorTheme: AceEditorTheme.Monokai,
  editor: { current: null },
  redo: noop,
  selectedImage: undefined,
  selectedAnchor: undefined,
  setSelectedImage: noop,
  setSelectedAnchor: noop,
  undo: noop,
};

export const SideBySideEditorContext = createContext(SIDE_BY_SIDE_EDITOR_CONTEXT_DEFAULT_VALUE);
export const useSideBySideEditorContext = () => useContext(SideBySideEditorContext);
